import {AbstractControl} from '@angular/forms';

export function showValidationError(control: AbstractControl | null, submitted = false): boolean {
    return !!control && control.invalid && (submitted || control.touched || control.dirty);
}
